module.exports = __webpack_public_path__ + "img/send-sms.3c82dcc0.svg";